import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import { WaveLoading } from 'react-loadingg'

import { jsPDF } from 'jspdf'

import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'
import { base64ToImageDownload, base64ToPdfDownload } from '../../../common/Utils.js'
import { getCountryTimeZone, getCurrency, getVat } from '../../../Constant.js'
import { Link } from 'react-router-dom'
import Button from '../../../common/CustomComponents/Button.js'
import EditCruiseTripBooking from './EditCruiseTripBooking.js'
import RefundModel from '../../Booking/Refund.js'
import CheckPermission from '../../../common/Permissions/CheckPermission.js'
import SendPayment from '../../Booking/SendPayment.js'
import ComplaintModel from '../../Booking/Complaint.js'
import ComplaintActionModel from '../../Booking/ComplaintAction.js'

class CruiseTripBookingDetail extends Component {
  state = {
    bookingData: null,
    refunded_amount: 0,

    currency: getCurrency('KWT'),
    country: 'KWT',
    isLoading: false,

    note: '',

    cabin_total_price: 0,

    cruise_img_base64: null,
    tripList: [],

    editBookingDetailsModel: false,
    refundModel: false,
    sendPaymentModel: false,
    complaintModel: false,
    complaintActionModel: false,
    selectedComplaintId: null,
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
  }

  componentDidMount() {
    this.getBookingDetails()
  }

  getBookingDetails = async () => {
    await axios
      .get(Constant?.getAPI() + '/trips/trip-booking-details/' + this.props?.match?.params?.id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState(
            {
              bookingData: res?.data?.data,
              currency: getCurrency(res?.data?.data?.country),
              country: res?.data?.data?.country,
            },
            async () => {
              // diwaniya_items total
              if (this.state?.bookingData?.cabin_bookings?.length > 0) {
                let totalAdultAmount = 0
                let totalChildAmount = 0
                this.state?.bookingData?.cabin_bookings?.forEach((element) => {
                  totalAdultAmount += element.cabin.adult_price * element.adult_tickets
                  totalChildAmount += element.cabin.child_price * element.child_tickets
                })

                this.setState({
                  cabin_total_price: totalAdultAmount + totalChildAmount,
                })
              }

              // let cruise_img_base64 = await this.imageUrlToBase64(
              //   Constant.getImage() + this.state.bookingData?.trip?.img
              // )

              // this.setState({ cruise_img_base64 })

              let refudedAmount = this.state.bookingData?.account_refund

              if (this.state.bookingData?.creator?.wallet?.length > 0) {
                refudedAmount += this.state.bookingData?.creator?.wallet?.reduce((acc, ele) => {
                  return acc + ele.amount
                }, 0)
              }

              this.setState({
                refunded_amount: refudedAmount,
              })
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'payment':
        var content
        if (this.state?.bookingData?.payment_details.length > 0) {
          content = `<div><table style="width:100%">
						<tbody>
							<tr>
							<th></th>
							${this.state?.bookingData?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
							</tr>
							<tr>
							<th>Payment ID</th>
							${this.state?.bookingData?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
							</tr>
							<tr>
							<th>Payment Status</th>
							${this.state?.bookingData?.payment_details
                .map(
                  (item) =>
                    `<td style="text-align: left">
										${item.payment_status || '--'}
										${
                      (item.payment_status === 'INITIATED' ||
                        item.payment_status === 'FAILED' ||
                        item.payment_status === 'PENDING') &&
                      item.payment_method_Id === 1
                        ? `<i 
													class="icofont icofont-refresh" 
													onclick="window.syncTripPaymentHandler('${item.id}')" 
													style="margin-left: 10px; cursor: pointer; color: #007bff; font-size: 18px;" 
													title="Sync Payment">
												</i>`
                        : ''
                    }
									</td>`
                )
                .join('')}
							</tr>
							<tr>
							<th>Payment Method</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
							</tr>
              <tr>
                <th>Payment Amount</th>
                ${this.state?.bookingData?.payment_details
                  .map(
                    (item) => `
                  <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                    ${item.payment_currency || this.state.currency} ${item.payment_amount}
                  </td>
                `
                  )
                  .join('')}
              </tr>
							<tr>
							<th>Transaction ID</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
							</tr>
							<tr>
							<th>Invoice Reference ID</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
							</tr>
							<tr>
							<th>Payment Created at</th>
							${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '--') + '</td>')}
							</tr>
						</tbody>
						</table>
						</div>
					`

          // Attach sync payment handler to window for button onclick
          window.syncTripPaymentHandler = (paymentId) => {
            this.syncPayment(paymentId)
          }

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  updateNote = async () => {
    if (this.state?.note?.length > 0) {
      const data = {
        booking_id: this.state.bookingData.id,
        comment: this.state.note,
      }

      await axios
        .post(Constant.getAPI() + '/trips/update-note', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Updated !', 'Note Updated', 'success')
            this.getBookingDetails()
            this.setState({
              note: '',
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  changeBookingDetails = async (state) => {
    if (moment(state?.start_date).format('YYYY-MM-DD') >= moment(state?.end_date).format('YYYY-MM-DD')) {
      Swal.fire('Error', `Start date should be less than end date`, 'error')
      return
    }

    this.setState({
      editBookingDetailsModel: false,
      isLoading: true,
    })

    let data = {
      booking_id: this.state?.bookingData?.id,
    }

    if (state?.type_tag && state?.type_tag != this.state.bookingData.type_tag) {
      data.type_tag = state?.type_tag
    }

    if (state?.booking_status && state?.booking_status != this.state.bookingData.booking_status) {
      data.booking_status = state?.booking_status
    }

    if (state?.selected_trip_id && state?.selected_trip_id != this.state.bookingData?.trip?.id) {
      data.trip_id = state?.selected_trip_id
    }

    if (state?.total_booking_amount && state?.total_booking_amount != this.state.bookingData?.total_booking_amount) {
      data.total_booking_amount = state?.total_booking_amount
    }

    await axios
      .post(Constant?.getAPI() + `/trips/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.getBookingDetails()
        this.setState({
          isLoading: false,
        })
      })
  }

  processRefund = async (state) => {
    if (!state?.refund_type) {
      Swal.fire('Refund Type Required!', '', 'error')
      return
    }
    this.setState({
      refundModel: false,
    })
    const data = {
      booking_id: this.state.bookingData.id,
      refund_type: state?.refund_type,
      refund_amount: state?.refund_amount,
      comment_en: `Amount of ${state?.refund_amount} refunded to ${state?.refund_type} - ${state?.comment_en}`,
      comment_ar: `كمية ${state?.refund_amount} ردها إلى ${state?.refund_type} - ${state?.comment_ar}`,
    }
    await axios
      .post(Constant.getAPI() + '/trips/trip-refund', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Refund Processed', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  sendPayment = async (state) => {
    if (!state?.amount) {
      Swal.fire('Amount Required!', '', 'error')
      return
    }

    this.setState({
      sendPaymentModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      amount: state?.amount,
    }

    await axios
      .post(Constant.getAPI() + '/trips/send-payment', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Request send successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  postComplaint = async (state) => {
    if (!state?.title) {
      Swal.fire('Title is Required!', '', 'error')
      return
    }
    if (!state?.description) {
      Swal.fire('Description is Required!', '', 'error')
      return
    }

    this.setState({
      complaintModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      title: state?.title,
      description: state?.description,
      type: 'CT',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint raised successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  syncPayment = async (paymentId) => {
    if (!paymentId) {
      Swal.fire({
        title: 'Payment ID is required',
        icon: 'error',
        type: 'error',
      })
      return
    }

    Swal.fire({
      title: 'Syncing Payment...',
      text: 'Please wait while we sync the payment status',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await axios
      .get(Constant.getAPI() + `/admin/sync-trip-payment/${paymentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getBookingDetails()
        Swal.fire('Success', 'Payment synced successfully', 'success')
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            type: 'error',
          })
        }
      })
  }

  handleComplaintAction = (complaintId) => {
    this.setState({ complaintActionModel: true, selectedComplaintId: complaintId })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: 'CT',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleStatusChange = async (id, status) => {
    const data = {
      complaint_id: id,
      status: status,
      type: 'CT',
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Status updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  downloadTicket = async (type = 'image', order_number, ticket_for = 'user') => {
    console.log(type, order_number)
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant?.getAPI() + `/auth/booking-tickets-v2`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          type: 'CT',
          order_number,
          ticket_for,
          lang: 'en',
          content_type: 'base64',
        },
      })
      .then(async (res) => {
        if (type == 'pdf') {
          base64ToPdfDownload(res.data, `cruise-trip-booking-${order_number}`)
        } else {
          base64ToImageDownload(res.data, `cruise-trip-booking-${order_number}`)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getBookingShareLink = async (number, code, order_number, user_type) => {
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant?.getAPI() + `/auth/booking-tickets-v2`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          type: 'CT',
          order_number,
          ticket_for: 'user',
          lang: 'en',
          content_type: 'base64',
        },
      })
      .then(async (res) => {
        this.handleShareLink(res.data, order_number, code, number, user_type)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  // save pdf to server
  handleShareLink = async (base64Data, order_number, code, number, user_type) => {
    var pdf = new jsPDF()
    pdf.addImage(base64Data, 'JPEG', 0, 0, 0, 297)

    const pdfName = `cruise-trip-booking-${order_number}.pdf`
    let pdfData = pdf.output('blob')

    const formData = new FormData()
    formData.append('pdfData', pdfData, pdfName)
    formData.append('pdfName', pdfName)

    await axios
      .post(Constant?.getAPI() + '/booking/save-booking-detail-pdf', formData, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          let phoneNumber = code + number
          phoneNumber.replace(/\+/g, '')

          let text = ''
          if (user_type == 'captain') {
            text = `Dear Partner,\nYou have a new booking, please find the following link:\n${Constant.getImage()}/public/booking/cruise-trip-booking-${order_number}.pdf`
          } else if (user_type == 'user') {
            text = `Dear User,\nThank you for booking with Waves! We are pleased to confirm your Booking.\nPlease find your booking confirmation by clicking on the following link:\n${Constant.getImage()}/public/booking/cruise-trip-booking-${order_number}.pdf`
          }

          text = encodeURIComponent(text)

          window.open(`whatsapp://send?phone=${phoneNumber}&text=${text}`)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <Modal
          open={this.state.editBookingDetailsModel}
          onClose={() => {
            this.setState({ editBookingDetailsModel: false })
          }}
          center
        >
          <EditCruiseTripBooking
            bookingDetails={this.state.bookingData}
            editBookingCruise={this.changeBookingDetails}
            tripList={this.state.tripList}
          ></EditCruiseTripBooking>
        </Modal>
        <Modal
          open={this.state.refundModel}
          onClose={() => {
            this.setState({ refundModel: false })
          }}
          center
        >
          <RefundModel
            refundAmount={
              parseFloat(this.state?.bookingData?.total_amount) +
                parseFloat(this.state?.bookingData?.wallet_applied_amount) -
                parseFloat(this.state?.refunded_amount) || 0
            }
            processRefund={this.processRefund}
          ></RefundModel>
        </Modal>
        <Modal
          open={this.state.sendPaymentModel}
          onClose={() => {
            this.setState({ sendPaymentModel: false })
          }}
          center
        >
          <SendPayment sendPayment={this.sendPayment}></SendPayment>
        </Modal>
        <Modal
          open={this.state.complaintModel}
          onClose={() => {
            this.setState({ complaintModel: false })
          }}
          center
        >
          <ComplaintModel
            postComplaint={this.postComplaint}
            type={'CT'}
          ></ComplaintModel>
        </Modal>
        <Modal
          open={this.state.complaintActionModel}
          onClose={() => {
            this.setState({ complaintActionModel: false })
          }}
          center
        >
          <ComplaintActionModel
            postAction={this.postAction}
            type={'CT'}
          ></ComplaintActionModel>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Trip Booking Details</h4>
                    </div>
                  </div>
                </div>
                {this.state?.bookingData && (
                  <div className="col-9">
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      onClick={() => {
                        this.downloadTicket('pdf', this.state.bookingData.order_number)
                      }}
                    >
                      <i className="icofont icofont-download m-r-5"></i> Ticket PDF
                    </Button>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      onClick={() => {
                        this.downloadTicket('image', this.state.bookingData.order_number)
                      }}
                    >
                      <i className="icofont icofont-download m-r-5"></i> Ticket Image
                    </Button>
                    {/* <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ editBookingDetailsModel: true })
                      }}
                    >
                      <i className="icofont icofont-ui-edit m-r-5"></i> Edit Booking
                    </Button> */}
                    <CheckPermission permission={'refund-booking'}>
                      <Button
                        className="btn btn-sm btn-inverse f-right m-l-5"
                        onClick={() => {
                          this.setState({ refundModel: true })
                        }}
                        disabled={
                          this.state?.refunded_amount >=
                          parseFloat(this.state?.bookingData?.total_amount) +
                            parseFloat(this.state?.bookingData?.wallet_applied_amount)
                        }
                      >
                        <i className="icofont icofont-ui-rotation m-r-5"></i> Refund
                      </Button>
                    </CheckPermission>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#5fcd85', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ sendPaymentModel: true })
                      }}
                    >
                      <i className="icofont icofont-card m-r-5"></i> Request Payment
                    </Button>
                    <Button
                      className="btn btn-sm btn-inverse f-right m-l-5"
                      style={{ backgroundColor: '#ee3a28', color: '#000' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ complaintModel: true })
                      }}
                    >
                      <i className="icofont icofont-contacts m-r-5"></i> Raise Complaint
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      {this.state?.bookingData ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking ID</div>
                                  <div>Booking Status</div>
                                  <div>Booking Type tag</div>
                                  <div>Booking Duration</div>
                                  <div>Issue date</div>
                                </div>
                                <div className="col-5">
                                  <div style={{ fontWeight: 'bolder' }}>
                                    {this.state.bookingData?.order_number || '--'}{' '}
                                    {this.state.bookingData?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{ height: 20 }}
                                      />
                                    )}
                                  </div>
                                  <div style={{ fontWeight: 'bolder', color: 'green' }}>
                                    {this.state?.bookingData?.booking_status == 'Cancelled' ? (
                                      <span className="badge badge-pill badge-warning">Cancelled</span>
                                    ) : this.state?.bookingData?.booking_status == 'Postponed' ? (
                                      <span className="badge badge-pill badge-warning">Postponed</span>
                                    ) : this.state?.bookingData?.booking_status == 'Confirmed' ? (
                                      <span className="badge badge-pill badge-success">Confirmed</span>
                                    ) : this.state?.bookingData?.booking_status == 'Successful' ? (
                                      <span className="badge badge-pill badge-success">Successful</span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.payment_status == true ? (
                                      <span className="badge badge-pill badge-warning">In Progress</span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning">In complete booking</span>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.type_tag || '--'}</div>
                                  <div>
                                    {this.state?.bookingData?.slot?.from_date
                                      ? moment(this.state?.bookingData?.slot?.from_date, 'YYYY-MM-DD').format(
                                          'DD MMM YYYY'
                                        )
                                      : ''}
                                    -
                                    {this.state?.bookingData?.slot?.to_date
                                      ? moment(this.state?.bookingData?.slot?.to_date, 'YYYY-MM-DD').format(
                                          'DD MMM YYYY'
                                        )
                                      : ''}
                                  </div>
                                  <div>
                                    <Moment format="DD MMM YYYY HH:mm:ss">{this.state?.bookingData?.createdAt}</Moment>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>User Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Customer Name</div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div style={{ height: 50 }}>Profile</div>
                                  )}
                                  <div>Phone</div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Email</div>}
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Device Type</div>}
                                  {localStorage.getItem('loged_In_role') === 'store' ? <></> : <div>Device Name</div>}
                                </div>
                                <div className="col-5">
                                  <div style={{ textTransform: 'capitalize' }}>
                                    {!this.state?.bookingData?.creator?.first_name &&
                                    !this.state?.bookingData?.creator?.last_name &&
                                    this.state?.bookingData?.creator?.is_guest
                                      ? 'Guest User'
                                      : this.state?.bookingData?.creator?.first_name &&
                                          this.state?.bookingData?.creator?.last_name
                                        ? this.state?.bookingData?.creator?.first_name +
                                          ' ' +
                                          this.state?.bookingData?.creator?.last_name
                                        : '--'}
                                  </div>
                                  <div style={{ height: 50 }}>
                                    <img
                                      src={
                                        this.state?.bookingData?.creator?.user_profile &&
                                        typeof this.state?.bookingData?.creator?.user_profile == 'string'
                                          ? Constant.getImage() + this.state?.bookingData?.creator?.user_profile
                                          : './assets/images/no_image.png'
                                      }
                                      className="img-fluid"
                                      alt="img"
                                      onError={(event) => {
                                        event.currentTarget.src = './assets/images/no_image.png'
                                      }}
                                      style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                    />
                                  </div>
                                  <div>
                                    {!this.state?.bookingData?.creator?.country_code &&
                                    !this.state?.bookingData?.creator?.phone
                                      ? '--'
                                      : this.state?.bookingData?.creator?.country_code +
                                        ' ' +
                                        this.state?.bookingData?.creator?.phone}
                                    {this.state.whatsAppShare != 'user' ? (
                                      <span
                                        onClick={() =>
                                          this.getBookingShareLink(
                                            this.state.bookingData.creator.phone,
                                            this.state.bookingData.creator.country_code,
                                            this.state.bookingData.order_number,
                                            'user'
                                          )
                                        }
                                        title="Booking Detail Share"
                                      >
                                        <img
                                          className="img-fluid m-l-5"
                                          src="./assets/images/whatsapp.png"
                                          alt="ico"
                                          style={{ width: 20 }}
                                        />
                                      </span>
                                    ) : (
                                      <div style={{ marginLeft: 10 }}>
                                        <WaveLoading
                                          color="#46C655"
                                          size="small"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>
                                      {this.state?.bookingData?.creator?.is_guest &&
                                      !this.state?.bookingData?.creator?.email
                                        ? 'Guest User'
                                        : this.state?.bookingData?.creator?.email
                                          ? this.state?.bookingData?.creator?.email
                                          : '--'}
                                    </div>
                                  )}
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>
                                      {this.state?.bookingData?.device_type == 'W'
                                        ? 'Website'
                                        : this.state?.bookingData?.device_type || '--'}
                                    </div>
                                  )}
                                  {localStorage.getItem('loged_In_role') === 'store' ? (
                                    <></>
                                  ) : (
                                    <div>{this.state?.bookingData?.device_name || '--'}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Trip Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Name</div>
                                  <div>Departure Location</div>
                                  <div>Arrival Location</div>
                                </div>
                                <div className="col-5">
                                  <div>{this.state.bookingData?.trip?.trip_name || '--'}</div>
                                  <div>{this.state.bookingData?.trip?.departure_location || '--'}</div>
                                  <div>{this.state.bookingData?.trip?.arrival_location || '--'}</div>
                                </div>
                              </div>
                              {localStorage.getItem('loged_In_role') === 'store' ? (
                                <></>
                              ) : (
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Coupon Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Coupon Code</div>
                                    <div>Coupon Type</div>
                                  </div>
                                  <div className="col-5">
                                    <div>{this.state?.bookingData?.bulk_coupon?.coupon_code}</div>
                                    <div>{this.state?.bookingData?.bulk_coupon?.coupon_type || '--'}</div>
                                  </div>
                                </div>
                              )}
                            </div>
                            {localStorage.getItem('loged_In_role') === 'store' ? (
                              <></>
                            ) : (
                              <div className="col-md-6 col-sm-12">
                                <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Payment Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>
                                      Payment Status
                                      <img
                                        className="img-fluid m-l-5"
                                        src="./assets/images/info.png"
                                        alt="ico"
                                        style={{ width: 13 }}
                                        onClick={() => this.showDetails('payment')}
                                      />
                                    </div>
                                    <div>Total Amount</div>
                                  </div>
                                  <div className="col-5">
                                    <div>{this.state?.bookingData?.payment_status === true ? 'True' : 'False'}</div>
                                    <div>
                                      {this.state?.currency + ' ' + this.state?.bookingData?.total_amount || '0'}
                                    </div>
                                  </div>
                                </div>
                                {/* <div
                                  className="row"
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="col-3"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Package Details</div>
                                  </div>
                                  <div
                                    className="col-4"
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    <div>Name</div>
                                    <div>Duration</div>
                                    <div>Price</div>
                                  </div>
                                  <div className="col-5">
                                    <div>{this.state?.bookingData?.package?.name_en || '--'}</div>
                                    <div>
                                      {this.state?.bookingData?.package?.start_day}--
                                      {this.state?.bookingData?.package?.end_day}
                                    </div>
                                    <div>{this.state?.bookingData?.package?.price || '--'}</div>
                                  </div>
                                </div> */}
                              </div>
                            )}
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10 }}
                          >
                            <div className="col-12">
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Cabin Details
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Cabin Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total Adult
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total Child
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total Adult Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total Child Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.cabin_bookings?.length > 0 &&
                                              this.state?.bookingData?.cabin_bookings.map((item) => (
                                                <tr
                                                  key={item.id}
                                                  style={
                                                    item?.payment_status
                                                      ? this.style.tableDataPaid
                                                      : this.style.tableDataUnpaid
                                                  }
                                                >
                                                  <td style={this.style.tableData}>{item?.cabin_name || '--'}</td>
                                                  <td style={this.style.tableData}>{item?.adult_tickets || '--'}</td>
                                                  <td style={this.style.tableData}>{item?.child_tickets || '--'}</td>
                                                  <td style={this.style.tableData}>
                                                    {item?.payment_status === true ? (
                                                      <span className="badge badge-success">Success</span>
                                                    ) : (
                                                      <span className="badge badge-danger">Pending</span>
                                                    )}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency +
                                                      ' ' +
                                                      item?.cabin?.adult_price * item?.adult_tickets}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency +
                                                      ' ' +
                                                      item?.cabin?.child_price * item?.child_tickets}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + item?.total_amount}
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Passenger Details
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Name</th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Email
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Phone
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Gender
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>DOB</th>
                                            </tr>
                                            {this.state?.bookingData?.passengers?.length > 0 &&
                                              this.state?.bookingData?.passengers.map((item) => (
                                                <tr
                                                  key={item.id}
                                                  style={this.style.tableDataPaid}
                                                >
                                                  <td style={this.style.tableData}>
                                                    {item?.first_name + ' ' + item?.last_name || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>{item?.email || '--'}</td>
                                                  <td style={this.style.tableData}>
                                                    {item?.country_code + ' ' + item?.phone || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {item?.gender == 'M' ? 'Male' : 'Female' || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>{item?.dob || '--'}</td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row"
                                style={{ borderBottom: '1px solid #ddd' }}
                              >
                                <div
                                  className="col-6"
                                  style={{ fontWeight: 'bold' }}
                                ></div>
                                <div className="col-6">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Price
                                              </th>
                                            </tr>

                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Trip Price'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.bookingData?.booking_amount || '0'}
                                              </td>
                                            </tr>
                                            {/* <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Cabin Amount'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.cabin_total_price || '0'}
                                              </td>
                                            </tr> */}
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Vat'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.vat_amount ||
                                                  ((this.state?.bookingData?.booking_amount || 0) *
                                                    getVat(this.state.country)) /
                                                    100 ||
                                                  '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Discount Coupon'}</td>
                                              <td style={{ ...this.style.tableData, color: 'red' }}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.coupon_applied_amount || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>
                                                {'Wallet Amount Applied'}
                                                {this.state?.bookingData?.wallet_applied_amount > 0 && (
                                                  <Link
                                                    to={
                                                      '/all-users/edit/user-wallet/' +
                                                      this.state?.bookingData?.customer?.id
                                                    }
                                                    className="m-r-15 text-muted"
                                                  >
                                                    <img
                                                      className="img-fluid m-l-5"
                                                      src="./assets/images/info.png"
                                                      alt="ico"
                                                      style={{ width: 13 }}
                                                    />
                                                  </Link>
                                                )}
                                              </td>
                                              <td style={{ ...this.style.tableData, color: 'red' }}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.wallet_applied_amount || '0'}
                                              </td>
                                            </tr>
                                            {/* <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {'Extra Payment'}
                                              </td>
                                              <td
                                                style={{
                                                  ...this.style.tableData,
                                                  fontWeight: 'bolder',
                                                  color: '#0004ff',
                                                }}
                                              >
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.extra_payment || '0'}
                                              </td>
                                            </tr> */}
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {'Total Amount'}
                                              </td>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {this.state?.currency} {this.state?.bookingData?.total_amount || '0'}
                                              </td>
                                            </tr>
                                            {this.state?.refunded_amount > 0 && (
                                              <>
                                                <tr>
                                                  <td></td>
                                                </tr>
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {'Refunded Amount'}
                                                  </td>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {this.state?.currency} {this.state?.refunded_amount || '0'}
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Booking History
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Comments
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change Time
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change by
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.booking_statuses?.length > 0 ? (
                                              this.state?.bookingData?.booking_statuses?.map((booking) => {
                                                return (
                                                  <tr
                                                    key={booking.id}
                                                    style={this.style.tableDataPaid}
                                                  >
                                                    <td style={this.style.tableData}>{booking.status}</td>
                                                    <td style={this.style.tableData}>{booking.comment}</td>
                                                    <td style={this.style.tableData}>
                                                      {moment(booking.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.created_by == 1
                                                        ? 'System'
                                                        : `${booking.user?.first_name} ${booking.user?.last_name} (${booking.user?.user_type})`}
                                                    </td>
                                                  </tr>
                                                )
                                              })
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Complaint History
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Title
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action Taken
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change Time
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Created by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Updated by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.complaints?.length > 0 ? (
                                              this.state?.bookingData?.complaints?.map((booking) => {
                                                return (
                                                  <tr
                                                    key={booking.id}
                                                    style={this.style.tableDataPaid}
                                                  >
                                                    <td style={this.style.tableData}>{booking.title}</td>
                                                    <td style={this.style.tableData}>{booking.description}</td>
                                                    <td style={this.style.tableData}>
                                                      <select
                                                        style={{ minWidth: 150 }}
                                                        className={`form-control`}
                                                        value={booking.status}
                                                        onChange={(e) =>
                                                          this.handleStatusChange(booking.id, e.target.value)
                                                        }
                                                      >
                                                        <option value="Open">Open</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="Resolved">Resolved</option>
                                                        <option value="Closed">Closed</option>
                                                      </select>
                                                    </td>
                                                    <td style={this.style.tableData}>{booking.action}</td>
                                                    <td style={this.style.tableData}>
                                                      {moment(booking.created_at)
                                                        .tz(
                                                          getCountryTimeZone(localStorage.getItem('countryShortName'))
                                                        )
                                                        .format('YYYY-MM-DD HH:mm:ss')}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.created_user?.first_name}{' '}
                                                      {booking.created_user?.last_name}{' '}
                                                      <b>({booking.created_user?.user_type})</b>
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.updated_user?.first_name}{' '}
                                                      {booking.updated_user?.last_name}{' '}
                                                      <b>({booking.updated_user?.user_type})</b>
                                                    </td>
                                                    <td style={{ ...this.style.tableData, paddingLeft: 35 }}>
                                                      <i
                                                        className="icofont icofont-edit"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.handleComplaintAction(booking.id)}
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              })
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Add Note
                                </div>
                                <div className="col-8">
                                  <textarea
                                    type="text"
                                    rows={4}
                                    className="form-control"
                                    name="note"
                                    placeholder="Add Note"
                                    onChange={this.handleChange}
                                    value={this.state.note}
                                  />
                                </div>
                                <div
                                  className="col-2 p-l-10"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <button
                                    onClick={() => {
                                      this.updateNote()
                                    }}
                                    className="btn btn-round btn-grd-disabled btn w-100"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <h6>Details not found</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseTripBookingDetail
